<template>
  <div v-bind:style="height != null ? 'height: ' + height + 'px;' : ''">
    <div
      @click="detail(param)"
      style="padding: 16px; border-right: 1px solid #e6e6e6"
      :class="selected ? 'selected' : ''"
    >
      <div class="sub_title_3">
        <span v-if="param.metricName != null">{{ param.metricName }}</span>
        <span v-if="param.unit != ''"> {{ "(" + param.unit + ")" }}</span>
      </div>
      <div class="d-flex mt-2">
        <div v-if="param.value != null" class="data_text_2">
          <span style="font-size: 20px; font-weight: 700">{{
            formattedNumber(param.value)
          }}</span>
        </div>
        <div
          v-if="param.achievement != null || param.trend != null"
          class="d-flex mt-2"
        >
          <div
            v-if="param.achievement != null"
            class="d-inline-flex align-items-center me-2"
            :class="
              param.achievementStatus === 'UP' ? 'badge_green' : 'badge_red'
            "
          >
            <IconSvg
              :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
              :type="
                param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'
              "
            />
            <div
              class="data_detil"
              v-bind:style="
                param.achievementStatus === 'UP'
                  ? 'color: green;'
                  : 'color: red;'
              "
            >
              {{ param.achievement }}
            </div>
          </div>
          <div
            v-if="param.trend != null"
            class="d-inline-flex align-items-center"
            :class="param.trendStatus === 'UP' ? 'badge_green' : 'badge_red'"
          >
            <IconSvg
              :color="param.trendStatus === 'UP' ? 'green' : 'red'"
              :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
            />
            <div
              class="data_detil"
              v-bind:style="
                param.trendStatus === 'UP' ? 'color: green;' : 'color: red;'
              "
            >
              {{ param.trend }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dataBudget: [],
      titleBudget: "",
      modalBudget: {
        show: false,
        load: false,
      },
    };
  },
  mounted() {},
  methods: {
    detail(x) {
      this.modalBudget.show = true;
      this.dataBudget = x;
      this.titleBudget = x.metricName + " " + x.unit;
    },
    onCloseModalBudget(value) {
      this.modalBudget.show = value;
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.selected {
  background-color: #ecf9ff;
}
</style>
